import BasicPropertyInfo from './BasicPropertyInfo';

export default class BuildingRiskDataPersonal extends BasicPropertyInfo {
	public occupancyType: string | null = null;
	public yearRoofLastUpdated: number | null = null;
	public isBelowGradeOrEnclosedAreaFinished: boolean | null = null;
	public isGarageAttached?: boolean | null = null;

	public constructor() {
		super();
	}
};